<div class="py-3">
  <div class="flex">
    <custom-label [placeholder]="placeholder"></custom-label>
    <div *ngIf="isRequired" class="text-red-500 ml-1 mt-1">*</div>
  </div>
  <span class="p-input-icon-left w-full" >
    <input
      [type]="type"
      border-round pInputText
      [placeholder]="placeholder"
      [formControl]="value"
      (blur)="onTouch()"
      [autocomplete]="autocomplete"
      class="border w-full"
    />
    <span *ngIf="eye" class="absolute right-0 top-0 h-full flex items-center pr-3 cursor-pointer" (click)="changeType.emit()">
      <i [class]="type === 'password' ? 'pi pi-eye eye ' : 'pi pi-eye-slash eye'"></i>
    </span>
    <span *ngIf="verified" class="absolute right-0 top-0 h-full flex items-center pr-3">
      <i class="pi pi-verified verified"></i>
    </span>
    <span *ngIf="wrong" class="absolute right-0 top-0 h-full flex items-center pr-3">
      <i class="pi pi-times-circle times"></i>
    </span>
  </span>
  <span *ngIf="form && isValidField()" class="block mt-3 ml-5 text-red-500 font-italic display-6">{{errorField()}}</span>
<div >
